.selectButton {
	display: flex;
	height: 40px;
	padding-inline: 15px;
	justify-content: space-between;
	align-items: center;
	align-self: stretch;
	border-radius: var(--BR-M, 4px);
	border: 1px solid var(--Negres-Text-Fields-Border, #d8e0e8);
	background: var(--Blancs-Superficie-Frame, #fff);
	outline: none;
	font-size: 16px;
	line-height: 18px;
	letter-spacing: 0.04px;
	font-weight: 400;
	min-width: 100px;
}

.select {
	position: relative;
	min-width: 100px;
}
.selectButton {
	width: 100%;
	color: var(--Negres-Text-Fields-Text-Input, #000);
	padding-right: 12px;
	cursor: pointer;
	&::after {
		content: '';
		width: 8px;
		height: 8px;
		flex-shrink: 0;
		margin-top: -4px;
		border-right: 2px solid currentColor;
		border-bottom: 2px solid currentColor;
		transform: rotate(45deg);
		transition: transform 180ms ease;
	}
}
.select[data-open='true'] .selectButton::after {
	transform: translateY(4px) rotate(225deg);
}
.options {
	position: absolute;
	z-index: 5;
	inset: calc(100% + 6px) 0 auto;
	display: grid;
	gap: 2px;
	margin: 0;
	padding: 4px;
	list-style: none;
	border: 1px solid var(--Negres-Text-Fields-Border, #d8e0e8);
	border-radius: var(--BR-M, 4px);
	background: var(--Blancs-Superficie-Frame, #fff);
	box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
	opacity: 0;
	transform: translateY(-6px) scale(0.98);
	transform-origin: top;
	pointer-events: none;
	transition:
		opacity 160ms ease,
		transform 160ms ease;
	button {
		width: 100%;
		min-height: 34px;
		padding: 8px 11px;
		border: 0;
		border-radius: calc(var(--BR-M, 4px) - 1px);
		background: transparent;
		color: var(--Negres-Text-Fields-Text-Input, #000);
		font: inherit;
		text-align: left;
		cursor: pointer;
		transition:
			background-color 140ms ease,
			color 140ms ease;
	}
	button:hover,
	button:focus-visible,
	[aria-selected='true'] button {
		background-color: var(--Grisos-Solids-Background, #f4f6f8);
		outline: none;
	}
}
.select[data-open='true'] .options {
	opacity: 1;
	transform: translateY(0) scale(1);
	pointer-events: auto;
}
